export class CancellablePromise<T> extends Promise<T> {
  constructor(
    executor: (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void
  ) {
    super(executor);
  }

  public isCancelled: boolean = false;

  public cancel(): void {
    this.isCancelled = true;
  }
}
